import { combineReducers, createReducer, unwrapResult } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import * as UserAction from './actions';

// This id is tax profile id. In future login and register should return user id not user tax profile id
const userId = createReducer('', (builder) => {
  builder.addCase(UserAction.setUser, (_, action) => unwrapResult(action));
});

const inviteData = createReducer({ advisorName: '', firmName: '' }, (builder) => {
  builder.addCase(UserAction.setInviteData, (_state, action) => action.payload);
});

const userReducer = combineReducers({
  id: userId,
  inviteData,
});

type UserReducer = ReturnType<typeof userReducer>;
const persistConfig: PersistConfig<UserReducer> = {
  key: 'user',
  storage,
};

export default persistReducer(persistConfig, userReducer);
